module.exports = __webpack_public_path__ + "img/ag.5aa1da2c.svg";